/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-support-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-support-api-client";
import type { BulkUploadLtxFilesMutationRequest, BulkUploadLtxFilesMutationResponse } from "../models/BulkUploadLtxFiles";
import { buildFormData } from "../.kubb/config";

export function getBulkUploadLtxFilesUrl() {
  const res = { method: 'POST', url: `/ltx-files/bulk-upload` as const }
  return res
}

/**
 * @description Upload multiple files for processing and storage. Files are processed sequentially.
 * @summary Bulk upload LTX files
 * {@link /ltx-files/bulk-upload}
 */
export async function bulkUploadLtxFiles(data: BulkUploadLtxFilesMutationRequest, config: Partial<RequestConfig<BulkUploadLtxFilesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data
  const formData = buildFormData(requestData)
  const res = await request<BulkUploadLtxFilesMutationResponse, ResponseErrorConfig<Error>, BulkUploadLtxFilesMutationRequest>({ method : "POST", url : getBulkUploadLtxFilesUrl().url.toString(), data : formData as FormData, ... requestConfig })
  return res.data
}